// Patientregistration/RegistrationRouter.tsx
import { lazy } from "react";
import useAuthentication from "@hooks/useAuthentication";

const RegistrationV1 = lazy(
  () => import("./v1/Registrationform")
);
const RegistrationV2 = lazy(
  () => import("./v2/Registrationform")
);

const RegistrationGrantsRouter = () => {
  const { user } = useAuthentication();
   const hasV2Access = user?.region=== "QATAR_REGION" 

  // example grant checks – adjust to your backend structure

  return hasV2Access ? <RegistrationV2 /> : <RegistrationV1/>;
};

export default RegistrationGrantsRouter;
